module.exports = __webpack_public_path__ + "static/media/add-coordinates.94d26012.svg";